import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import PropTypes from 'prop-types'
import i18next from 'i18next'

import BankProvisionalSummary from './BankProvisionalSummary'
import PayBankSummary from './payBank/PayBankSummary'
import PayBankVacationSummary from './vacationBank/VacationBankSummary';

const useStyles = makeStyles((theme) => ({
    divRoot: {
        width: '100%'
    },
    divTab: {
        alignSelf: 'center',
    },
    appBar: {
    }
}));

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

export default function TabBankSummary(props) {
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);
    const [activeProvisional, setActiveProvisional] = React.useState(true);

    const { data, typeSolde } = props;

    const classes = useStyles();

    useEffect(() => {
        const type = data[0].bankType === 'M' ? "amount" : "unit";
        setActiveProvisional(type === 'amount');
        if (type === 'amount') {
            setValue(1);
            setIndex(1);
        }
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleItemProvisionalClick = () => {
        setIndex(0);
    }

    const handleItemBankClick = () => {
        setIndex(1);
    }

    return (
        <React.Fragment>
            <div className={classes.divRoot}>
                <AppBar position="static" color="default" className={classes.appBar}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="standard"
                        indicatorColor="primary"
                        textColor="primary"
                        className={classes.divTab}
                    >
                        <Tab disabled={activeProvisional} label={i18next.t("bankBalance:form.provisionalUnitBalance")} {...a11yProps(0)} onClick={handleItemProvisionalClick} />
                        <Tab label={i18next.t("bankBalance:form.bankBalance")} {...a11yProps(1)} onClick={handleItemBankClick} />
                    </Tabs>
                </AppBar>

                {index == 0 && <BankProvisionalSummary data={data} />}
                {typeSolde == 0 && index == 1 && <PayBankSummary data={data} />}
                {typeSolde == 1 && index == 1 && <PayBankVacationSummary data={data} />}
            </div>
        </React.Fragment>
    );
}

TabBankSummary.propTypes = {
    data: PropTypes.array.isRequired,
    typeSolde: PropTypes.number.isRequired
}